import script from "./LiveGuide.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiveGuide.vue?vue&type=script&setup=true&lang=ts"

import "./LiveGuide.vue?vue&type=style&index=0&id=07ae9c1f&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07ae9c1f"]])

export default __exports__